module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/monitor-pc/keyboard.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/monitor-pc/keyboard.jpg
// module id = 596
// module chunks = 0